const STORE_KEY = "__AO_CHAT_VIEWPORT_STATE__";

const getId = (value) => String(value?._id || value?.id || value || "").trim();

const getStore = () => {
    if (typeof window === "undefined") return null;

    if (!(window[STORE_KEY] instanceof Map)) {
        window[STORE_KEY] = new Map();
    }

    return window[STORE_KEY];
};

export const isPageEngaged = () => {
    if (typeof document === "undefined") return true;

    // Для чата важна именно видимость вкладки, а не focus окна.
    // Два браузера могут стоять рядом: пользователь пишет справа, но чат слева
    // всё равно полностью виден. document.hasFocus() в таком случае false,
    // однако показывать toast/unread поверх уже видимого чата не нужно.
    return document.hidden !== true && document.visibilityState !== "hidden";
};

export const setChatViewportState = ({ instanceId, chatId, atBottom = false } = {}) => {
    const store = getStore();
    const key = String(instanceId || "").trim();
    const cleanChatId = getId(chatId);

    if (!store || !key || !cleanChatId) return;

    store.set(key, {
        chatId: cleanChatId,
        atBottom: !!atBottom,
        updatedAt: Date.now(),
    });
};

export const clearChatViewportState = (instanceId) => {
    const store = getStore();
    const key = String(instanceId || "").trim();

    if (!store || !key) return;
    store.delete(key);
};

const hasMatchingViewport = (chatId, predicate) => {
    const store = getStore();
    const cleanChatId = getId(chatId);

    if (!store || !cleanChatId) return false;

    for (const state of store.values()) {
        if (getId(state?.chatId) !== cleanChatId) continue;
        if (predicate(state)) return true;
    }

    return false;
};

export const isChatContextVisible = (chatId) => {
    if (!isPageEngaged()) return false;
    return hasMatchingViewport(chatId, () => true);
};

export const isChatMessageActuallySeen = (chatId) => {
    if (!isPageEngaged()) return false;
    return hasMatchingViewport(chatId, (state) => state?.atBottom === true);
};
